import React, { useEffect } from 'react';
import axios from 'axios';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authService } from '@S';

const PaymentConfirmation = () => {
  const account_id = authService.currentAccountID;
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [showMessage, setShowMessage] = React.useState(false);
  const [showRetry, setShowRetry] = React.useState(false);

  useEffect(() => {
    getPaymentStatus();
  }, []);

  const getPaymentStatus = () => {
    //get orderTrackingId from url query params
    const urlParams = new URLSearchParams(window.location.search);
    const orderTrackingId = urlParams.get('OrderTrackingId');
    setShowRetry(false);
    if (orderTrackingId) {
      axios
        .get(
          `${process.env.API_URL}/payment/gate-way/?order_tracking_id=${orderTrackingId}`,
        )
        .then((response) => {
          //show success message

          setLoading(false);
          setMessage(`${response.data.data.payment_status_description}`);
          if (account_id) {
            // redirect user to account page after 5 seconds
            setShowMessage(true);
            setTimeout(() => {
              window.location.href = `/logout`;
            }, 5000);
          } else {
            setShowMessage(true);
            setTimeout(() => {
              window.location.href = `/login`;
            }, 5000);
          }
        })
        .catch((error) => {
          setLoading(false);
          setShowRetry(true);
          setMessage('An error occurred while fetching payment status');
          console.log('Error fetching payment status:', error);
        });
    } else {
      alert('OrderTrackingId not found');
    }
  };

  if (loading) {
    return <DropLoaderLarge />;
  } else {
    return (
      <main>
        <div className="page-wrapper no-access">
          <div className="page-content">
            <section className="">
              <div className="access-forbidden" style={{ textAlign: 'center' }}>
                <h1>Payment Confirmation</h1>
                <p style={{ margin: '5px 0px' }}>{message}</p>
                {showMessage && <p>You will be redirected in 5 seconds</p>}
                {showRetry && (
                  <button
                    className="btn btn-primary"
                    style={{
                      background: '#158289',
                      color: '#ffffff',
                      padding: '10px 25px',
                      marginTop: '5px',
                    }}
                    onClick={() => getPaymentStatus()}
                  >
                    Retry
                  </button>
                )}
              </div>
            </section>
          </div>
        </div>
      </main>
    );
  }
};

export { PaymentConfirmation };
